export default {"src":"/_next/static/media/inbound.7626a90a.gif","height":480,"width":1022,"blurWidth":0,"blurHeight":0};